
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 496.8 524","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M480.8 498h-21.9V179.5c0-14.8-12.1-26.9-26.9-26.9h-49c-14.8 0-26.9 12.1-26.9 26.9V498h-55.7V323.8c0-14.8-12.1-26.9-26.9-26.9h-49c-14.8 0-26.9 12.1-26.9 26.9V498h-55.7v-90.2c0-14.8-12.1-26.9-26.9-26.9H66c-14.8 0-26.9 12.1-26.9 26.9V498H16c-5.5 0-10 4.5-10 10s4.5 10 10 10h464.8c5.5 0 10-4.5 10-10s-4.5-10-10-10zm-358.9 0H59.1v-90.2c0-3.8 3.1-6.9 6.9-6.9h49c3.8 0 6.9 3.1 6.9 6.9V498zm158.5 0h-62.8V323.8c0-3.8 3.1-6.9 6.9-6.9h49c3.8 0 6.9 3.1 6.9 6.9V498zm158.5 0h-62.8V179.5c0-3.8 3.1-6.9 6.9-6.9h49c3.8 0 6.9 3.1 6.9 6.9V498zM458.8 16.5c.1-2.7-.8-5.5-2.9-7.6-2.1-2.1-4.9-3-7.6-2.9h-61c-5.5 0-10 4.5-10 10s4.5 10 10 10h37.4l-98.9 98.9-37.3-37.3c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9L94.7 267.3c-3.9 3.9-3.9 10.2 0 14.1 2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l172.7-172.7 37.3 37.3c3.9 3.9 10.2 3.9 14.1 0L438.9 40.1V74c0 5.5 4.5 10 10 10s10-4.5 10-10V17c0-.2-.1-.3-.1-.5z"}}),_c('circle',{staticClass:"st0",attrs:{"cx":"68","cy":"309.3","r":"10"}})])
          )
        }
      }
    